import { useCallback } from 'react';
import { parseMCPError, parseMCPResponse } from '../../utils/messageUtils';

export const useResponseHandlers = (chatState) => {
  const { addAIMessage, updateExtractedData, updateConversationHistory, setShowFormPreview } = chatState;

  const handleMCPError = useCallback((data, userInput) => {
   
    
    const fullErrorMessage = parseMCPError(data);
    
    addAIMessage(fullErrorMessage);
    
    updateConversationHistory(userInput, JSON.stringify({
      message: fullErrorMessage,
      extractedData: {},
      status: 'error'
    }));
  }, [addAIMessage, updateConversationHistory]);

  const handleSuccessResponse = useCallback((data, userInput) => {
    
    const responseData = parseMCPResponse(data.data);
     
    addAIMessage(
      responseData.message || 'Respuesta recibida sin mensaje',
      responseData.extractedData || {},
      {
        missingFields: responseData.missingFields || [],
        suggestions: responseData.suggestions || [],
        debugInfo: responseData.debugInfo || null,
        openaiStatus: responseData.openaiStatus || null
      }
    );

    // Accumulate extracted data from previous messages
    updateExtractedData(responseData.extractedData || {});
    
    updateConversationHistory(userInput, JSON.stringify({
      message: responseData.message || 'Respuesta recibida',
      extractedData: responseData.extractedData || {},
      status: responseData.status || 'incomplete'
    }));

    if (data.data.status === 'complete') {
      setShowFormPreview(true);
    } 
  }, [addAIMessage, updateExtractedData, updateConversationHistory, setShowFormPreview]);

  const handleErrorResponse = useCallback((data, userInput) => {
    const errorMessage = data.error || 'Lo siento, hubo un error procesando tu mensaje. ¿Podrías intentar de nuevo?';
    
    addAIMessage(errorMessage);
    updateConversationHistory(userInput, JSON.stringify({
      message: errorMessage,
      extractedData: {},
      status: 'error'
    }));
  }, [addAIMessage, updateConversationHistory]);

  const handleNetworkError = useCallback((error, userInput) => {
    const errorMessage = 'Lo siento, estoy teniendo dificultades técnicas. ¿Podrías intentar de nuevo?';
    
    addAIMessage(errorMessage);
    updateConversationHistory(userInput, JSON.stringify({
      message: errorMessage,
      extractedData: {},
      status: 'error'
    }));
  }, [addAIMessage, updateConversationHistory]);

  return {
    handleMCPError,
    handleSuccessResponse,
    handleErrorResponse,
    handleNetworkError
  };
};
